import produce from 'immer';
import { Reducer, handleActions, Action } from 'redux-actions';
import { action } from 'typesafe-actions';

export enum LoadingTypes {
  setAsync = '@loading/setAsync'
}

export interface LoadingState {
  asyncMap: { [key: string]: number };
}

export const LoadingActions = {
  setAsync: (key: string, value: boolean) => action(LoadingTypes.setAsync, { key, value })
};

const initialState: LoadingState = {
  asyncMap: {}
};

export default handleActions<LoadingState, any>(
  {
    [LoadingTypes.setAsync]: (state, action: Action<{ key: string; value: boolean }>) => {
      return produce(state, draft => {
        const { key, value } = action.payload;
        if (draft.asyncMap[key] === undefined) {
          draft.asyncMap[key] = 0;
        }

        if (value) {
          draft.asyncMap[key]++;
        } else if (draft.asyncMap[key] > 0) {
          draft.asyncMap[key]--;
        }
      });
    }
  },
  initialState
);
